import React from 'react';
import i18n from 'lib/i18n';
import Container from './components/Container';
import Title from './components/Title';
import RuleList from './components/RuleList';

const IVPRuleList = () => (
    <Container>
        <Title>{i18n._('Vulnerability Protection Rules')}</Title>
        <RuleList/>
    </Container>
);

export default IVPRuleList;
